// extracted by mini-css-extract-plugin
module.exports = {"seamlessUpdates":"SeamlessUpdates_seamlessUpdates__U_y3W","ef-box":"SeamlessUpdates_ef-box__uSBeT"};